import { SaveDocumentRequest } from '../model/transport-document';
import { UntypedFormGroup } from '@angular/forms';
import { DocumentService } from '../service/document.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Document } from '../model/document';
import { DocumentViewModel } from '../model/document-view-model';
import { TranslationService } from '@sdbn/common';



@Component({
    selector: 'app-document-dialog',
    templateUrl: './document-dialog.component.html',
    styleUrls: ['./document-dialog.component.scss'],
    standalone: false
})
export class DocumentDialogComponent implements OnInit {

  newDocumentId = -1;

  loaded = false;

  errorMsg: string;

  viewModels: DocumentViewModel[] = [];

  visibleViewModels: DocumentViewModel[] = [];

  selectedModel: DocumentViewModel;

  documentTemplateId: number;

  form = new UntypedFormGroup({});

  constructor(
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<DocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translationService: TranslationService) { }

  ngOnInit() {
    this.documentTemplateId = this.data.documentTemplateId;

    if (this.data.documentIds == null || this.data.documentIds.length === 0) {
      this.documentService.createDocument(this.documentTemplateId).subscribe(document => {
        document.id = this.newDocumentId--;
        const doc = new Document(document);
        doc.transportId = this.data.transportId;
        this.viewModels.push(new DocumentViewModel(doc, new UntypedFormGroup({})));
        this.viewModels[0].selected = true;
        this.selectedModel = this.viewModels[0];
        this.updateVisibleViewModels();
        this.loaded = true;
      });
    } else {
      this.documentService.getDocuments(this.data.documentIds).subscribe(documents => {
        for (const document of documents) {
          const doc = new Document(document);
          doc.transportId = this.data.transportId;
          this.viewModels.push(new DocumentViewModel(doc, new UntypedFormGroup({})));
        }
        this.viewModels[0].selected = true;
        this.selectedModel = this.viewModels[0];
        this.updateVisibleViewModels();
        this.loaded = true;
      });
    }
  }

  getTitle(): string {
    if (this.viewModels != null
      && this.viewModels.length > 0
      && this.viewModels[0].document.template != null
      && this.viewModels[0].document.template.nameDictionaryKey != null
      && this.viewModels[0].document.template.nameDictionaryKey.length > 0) {
      return this.translationService.translate(this.viewModels[0].document.template.nameDictionaryKey);
    }
    return this.translationService.translate('tmc.document.dialog.title');
  }

  close() {
    this.dialogRef.close();
  }

  public save() {

    const documents = new Array<SaveDocumentRequest>();

    for (const viewModel of this.viewModels) {
      const transportDocument = new SaveDocumentRequest();
      transportDocument.document = viewModel.document;
      transportDocument.document.title = viewModel.title;
      transportDocument.metaData = JSON.stringify(this.data.metaData);
      documents.push(transportDocument);
    }

    this.documentService.saveDocuments(documents).subscribe(
      result => {
        this.dialogRef.close(result);
      },
      error => {
        this.showErrorMessage('tmc.dialog.error.save');
      }
    );
  }

  private showErrorMessage(messageKey: string) {
    this.errorMsg = this.translationService.translate(messageKey);
  }

  public setSelectedModel(model: DocumentViewModel) {
    this.viewModels.forEach(vm => vm.selected = false);
    model.selected = true;
    this.selectedModel = model;
  }

  public deleteDocument(model: DocumentViewModel) {

    let filtered = this.viewModels.filter(vm => !vm.document.deleted);
    const indexOfDeleted = filtered.indexOf(model);

    if (model.document.id < 0) {
      this.viewModels.splice(indexOfDeleted, 1);
    } else {
      model.document.deleted = true;
    }

    filtered = this.viewModels.filter(vm => !vm.document.deleted);

    // wenn das letzte Dokument gelöscht wurde, wird ein leeres dokument angelegt
    if (filtered.length === 0) {
      this.documentService.createDocument(this.documentTemplateId).subscribe(document => {
        document.id = this.newDocumentId--;
        const newModel = new DocumentViewModel(new Document(document), new UntypedFormGroup({}));
        this.viewModels.push(newModel);
        this.updateVisibleViewModels();
        this.setSelectedModel(newModel);
      });
    } else {
      this.updateVisibleViewModels();
      if (indexOfDeleted > 0) {
        this.setSelectedModel(filtered[indexOfDeleted - 1]);
      } else {
        this.setSelectedModel(filtered[0]);
      }
    }
  }

  public addDocument() {
    this.documentService.createDocument(this.documentTemplateId).subscribe(document => {
      document.id = this.newDocumentId--;
      const model = new DocumentViewModel(new Document(document), new UntypedFormGroup({}));
      this.viewModels.push(model);
      this.updateVisibleViewModels();
      this.setSelectedModel(model);
    });
  }

  private updateVisibleViewModels() {
    this.visibleViewModels = this.viewModels.filter(vm => !vm.document.deleted);
  }

  public isSaveDisabled(): boolean {

    for (const model of this.viewModels) {
      if (model.form.invalid) {
        return true;
      }
    }

    return false;
  }

}
